import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ScheduleSRPortal } from '../ScheduleSRPortal';
import {
  ACCESS_TOKEN_COOKIE,
  ID_TOKEN_COOKIE,
  envUrl,
  envUrlSRPortal,
  routes,
} from '../../config';
import cookieService from '../../services/cookieService';
import providerService from '../../services/providerService';
import headerCancelModal from '../../actions/headerCancelModalAction';

const srPortalConfig = {
  enabled: true,
  scheduleSRPortalScriptPath: `${envUrlSRPortal}/static/chunks/remoteEntry.js`,
  apiBaseUrl: envUrlSRPortal,
};

const CreateServiceRequest = ({ country, lang }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const locationState = location.state;

  const modalTrigger = useSelector(
    (payload) => payload.headerCancelModal,
  );
  const professional = useSelector((state) => state.userDetails);

  const accessToken = cookieService.getCookie(ACCESS_TOKEN_COOKIE);
  const idToken = cookieService.getCookie(ID_TOKEN_COOKIE);
  const { providerId } = providerService.getProviderDetails();
  const logoutUrl = `${envUrl}${routes.dpx.logout}`;

  const returnPath =
    locationState?.returnPath ||
    `/${country}/${lang}/${routes.dpx.patient}`;

  // Handle header cancel (x) button click
  useEffect(() => {
    if (modalTrigger) {
      dispatch(headerCancelModal(false));
      history.push(returnPath);
    }
  }, [modalTrigger]);

  // Guard: redirect back if no state was passed (e.g. direct URL access or page refresh)
  useEffect(() => {
    const resolvedId =
      locationState?.patientId ||
      locationState?.patientDetails?.patientId;
    if (!resolvedId || !locationState?.deviceData) {
      history.replace(`/${country}/${lang}/${routes.dpx.home}`);
    }
  }, []);

  const {
    patientId: statePatientId,
    deviceData,
    patientDetails,
    clinicDetails,
    countryCode,
  } = locationState || {};

  const patientId = statePatientId || patientDetails?.patientId;

  // TODO: Remove temporary logging
  // eslint-disable-next-line no-console
  console.log('CreateServiceRequest - locationState:', locationState);
  // eslint-disable-next-line no-console
  console.log(
    'CreateServiceRequest - resolved patientId:',
    patientId,
  );

  if (!patientId || !deviceData) {
    return null;
  }

  return (
    <div id="main-content">
      <div className="ccl__dpx_center-832">
        <ScheduleSRPortal
          config={srPortalConfig}
          accessToken={accessToken}
          idToken={idToken}
          selectedProviderId={providerId}
          pageType="CreateServiceRequest"
          logoutUrl={logoutUrl}
          deviceData={deviceData}
          patientId={patientId}
          countryCode={countryCode}
          patientDetails={patientDetails}
          clinicDetails={clinicDetails}
          professionalDetails={{
            professionalId: professional?.professionalId,
            firstName: professional?.firstName,
            lastName: professional?.lastName,
            email: professional?.username,
          }}
        />
      </div>
    </div>
  );
};

export default CreateServiceRequest;
